import { useHttp } from '../http'

export const useTagHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`tags/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`tags`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`tags/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`tags`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`tags/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
